import * as Glob from "./Globale";
import { extend } from "jquery";

export interface Dictionary<T> {
    [Key: string]: T;
}

//export class CDictionary<T>{
//    [Key: string]: T;
//}

export interface IDictionary<T> {
    Add(key: string, value: T): void;
    ContainsKey(key: string): boolean;
    Count(): number;
    Item(key: string): T;
    Keys(): string[];
    Remove(key: string): T;
    Values(): T[];
}

export class CDictionary<T> implements IDictionary<T> {
    private items: { [index: string]: T } = {};

    private count: number = 0;

    public ContainsKey(key: string): boolean {
        return this.items.hasOwnProperty(key);
    }

    public Count(): number {
        return this.count;
    }

    public Add(key: string, value: T) {
        if (!this.items.hasOwnProperty(key)) this.count++;

        this.items[key] = value;
    }

    public Remove(key: string): T {
        var val = this.items[key];
        delete this.items[key];
        this.count--;
        return val;
    }

    public Item(key: string): T {
        return this.items[key];
    }

    public Keys(): string[] {
        var keySet: string[] = [];

        for (var prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                keySet.push(prop);
            }
        }

        return keySet;
    }

    public Values(): T[] {
        var values: T[] = [];

        for (var prop in this.items) {
            if (this.items.hasOwnProperty(prop)) {
                values.push(this.items[prop]);
            }
        }

        return values;
    }

    public Set(key: string, value: T) {
        this.items[key] = value;
    }

    public LoadFromJSON(json: Glob.DatiJSON) {
        this.items = JSON.parse(json);
    }

    public GetJSON(): Glob.DatiJSON {
        let json: Glob.DatiJSON = "";

        let keys: string[] = this.Keys();
        let delimitatore: string = "";

        if (keys.length > 0 && typeof this.Item(keys[0]) == "string") {
            delimitatore = '"';
        }

        for (var i: number = 0; i < keys.length; i++) {
            json += '"' + keys[i] + '": ' + delimitatore + this.Item(keys[i]) + delimitatore + ",";
        }

        if (json.length > 3) json = json.substring(0, json.length - 1);

        json = "{" + json + "}";
        return json;
    }

    public GetDictionary(): Dictionary<T> {
        return this.items;
    }

    public GetDictionaryJSON(): Glob.DatiJSON {
        return JSON.stringify(this.GetDictionary());
    }

    public LoadFromDictionary(dictionary: Dictionary<T>) {
        this.items = dictionary;
    }

    //public LoadFromJSON(json: Glob.DatiJSON) {
    //    this.items = {};

    //    let arrayTemp: any[] = JSON.parse(json);
    //    for (var i: number = 0; i < arrayTemp.length; i++) {
    //        let obj = arrayTemp[i];
    //        let values: any = Object.getOwnPropertyDescriptor(obj, Object.getOwnPropertyNames(obj)[0]);
    //        if (values != undefined) {
    //            let key: string = Object.getOwnPropertyNames(obj)[0];
    //            let value: T = values.value;
    //            this.Add(key, value);
    //        }
    //    }
    //}

    //public GetJSON(): Glob.DatiJSON {
    //    let json: Glob.DatiJSON = "";

    //    let keys: string[] = this.Keys();
    //    let delimitatore: string = "";

    //    if (keys.length > 0 && typeof(this.Item(keys[0])) == "string") {
    //        delimitatore = "\"";
    //    }

    //    for (var i: number = 0; i < keys.length; i++) {
    //        json += "{\"" + keys[i] + "\": " + delimitatore + this.Item(keys[i]) + delimitatore + "},";
    //    }

    //    if (json.length > 3)
    //        json = json.substring(0, json.length - 1);

    //    json = "[" + json + "]";
    //    return json;
    //}
}

export class CRisAPI {
    Errore: boolean = false;
    ErrTesto: string = "";
    ErrTesti: string[] = [];
    ID_Chiave: number = 0;
    MessaggioTesto: string = "";
    MessaggioDati: any = undefined;
}

export class CRisAPIDato<T> extends CRisAPI {
    Dato: T = {} as T;
}

export class CRisAPISemplice<T> extends CRisAPI {
    Dato: T = {} as T;
}

export class CRisAPIDizionario<T> extends CRisAPI {
    Dati: Dictionary<T> = {};
}

export type TListaParametri = { [G: string]: string };

export type TListaParametriDeroga = { [G: string]: CTipoCampoDeroga };

export class CTipoCampoDeroga {
    Verso: string = "";
    Valore: string = "";
    Tipo: string = "";
}

export class CParamAPIPagine {
    Sessione: string = "";
    Pagina: number = 0;
    Numero: number = 0;
}

//TODO Eliminare e passare il parametro tramite il dictionary dei parametri, vedi BinderLista
export class CParamAPIPagineAnagrafica extends CParamAPIPagine {
    ID_Anag: number = 0;
}

//TODO Eliminare e passare il parametro tramite il dictionary dei parametri, vedi BinderLista
export class CParamAPIPagineDatiEconomici extends CParamAPIPagine {
    ID_Anag: number = 0;
}

export class CRisAPIPagine<T> extends CRisAPI {
    PaginaCorrente: number = 0;
    Pagine: number = 0;
    RigheTotali: number = 0;
    Dati: T[] = [];
}

export class CRisAPILista<T> extends CRisAPI {
    Dati: T[] = [];
}

export class CDatiLimite {
    Tipo: string = "";
    ID_TipoRamo: number = 0;
    TipoRamo: string = "";
    ID_TipoProdotto?: number = 0;
    TipoProdotto: string = "";
    ID_TipoGruppoLimite: string = "";
    ID_Gruppo: string = "";
    Valore: number = 0;
    ValoreMAX: number = 0;
}

export class CRisAPI_DatiLimiti extends CRisAPI {
    Dati: CDatiLimite[] = [];
}

export class CRisAPI_DatiLimitiBinder extends CRisAPI {
    ImportoGarantito: number = 0;
    RiduzioneSommaGarantita?: number = undefined;
}

export class CRisAPIExtra<TRisAPI, TExtra> {
    RisAPI: TRisAPI = {} as TRisAPI;
    Extra: TExtra = {} as TExtra;
}

export class CTipo {
    constructor(id_Chiave: string, valore: string) {
        this.ID_Chiave = id_Chiave;
        this.Valore = valore;
    }
    ID_Chiave: string = "";
    Valore: string = "";
    Selezionato: boolean = false;
    Disabilitato: boolean = false;
    Etichetta: string = "";
    ID_TipoContesto: string = "";
    Parametri: any[] = [];
    Codice: string = "";
    Permesso?: string[] = undefined;
}

export class CDatoRubrica {
    ID_Tipologia: number = 0;
    Valore: string = "";
    TipoRecapito: string = "";
}

export class CDatoIndirizzo {
    Indirizzo: string = "";
    Citta: string = "";
    Cap: string = "";
    Provincia: string = "";
    Nazione: string = "";
    Tipo: number[] = [];
}

export class CDatoMandante {
    ID_Anag: number = 0;
    Capogruppo: boolean = false;
    RagioneSociale: string = "";
    PartitaIVA: string = "";
    Quota: number = 0;
}

export class CDatoCoAssicurazione {
    ID_Anag: number = 0;
    Delegataria: boolean = false;
    Quota: number = 0;
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
}

export class CDatoBinderProdottoCoAssicurazione {
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
    CodiceBinder: string = "";
    ID_AnagDa: number = 0;
    Denominazione: string = "";
    DenominazioneCompagnia: string = "";
    ID_AnagCompagnia: number = 0;
    DataEffetto: Date = new Date(Date.now());
    DataFine: Date = new Date(Date.now());
    LimitePerSingoloProdotto: number = 0;
    LimitePerSingoloContraente: number = 0;
    LimiteDirittiFissi: number = 0;
    LimiteAccessori: number = 0;
    PremioMinimo: number = 0;
    CoAssicurazioneMinima: number = 0;
    CoAssicurazioneSoloDelegataria: boolean = false;
    Quota: number = 0; //Usato solo per l'interfaccia grafica
    TassoMin: number = 0;
    Delegataria: boolean = false; //Usato solo per l'interfaccia grafica
}

export class CTipoDati extends CTipo {
    Dati: { [D: string]: string } = {};
}

export class CTipoDatiJSON extends CTipo {
    Dati: any;
}

export class CIngrAPI<T> {
    Dato: T = {} as T;
}

export class CIngrAPILista<T> {
    Dati: T[] = [];
}

export class CIngrAPIExtra<T, S> {
    IngrApi: T = {} as T;
    Extra: S = {} as S;
}

export type TDictTipo = { [T: string]: CTipo };

export class CIngrAPITipi<T> {
    Tipi: { [T: string]: TDictTipo };
    Dato: T = {} as T;
    constructor() {
        this.Tipi = {};
    }
}

export class CIngrAPIListaTipi<T> {
    Tipi: { [T: string]: TDictTipo };
    Dati: T[] = [];
    constructor() {
        this.Tipi = {};
        this.Dati = [];
    }
}

export class CInfoCampo {
    TipoProdotto: string = "";
    Campo: string = "";
    Gruppo: string = "";
    SottoGruppo: string = "";
    Etichetta: string = "";
    Richiesto: boolean = false;
    RegEx: string = "";
    Min: string = "";
    Max: string = "";
    Precisione: number = 0;
    Dipendenza: string = "";
    SolaLettura: boolean = false;
    ID_TipoCampo: number = 0;
    TipoTabella: string = "";
    TipoJSON: Glob.DatiJSON = "";
    ParametriJSON: Glob.DatiJSON = "";
    Derogabile: boolean = false;
    DerogaVerso: string = "";
}

export class CProvvigioni {
    ID_ProvvigioneRiga: number = 0;
    ID_Provvigione: number = 0;
    ID_Anag: number = 0;
    ID_TipoRamo: number = 0;
    TipoRamo: string = "";
    ID_TipoProdotto: number = 0;
    TipoProdotto: string = "";
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
    DenominazioneCompagnia: string = "";
    ProvvigioniJSON: Glob.DatiJSON = '[{"Funzione":"","Parametri":{}}]';
}

export class CRisAPIProvvigioni extends CRisAPILista<CProvvigioni> {
    constructor() {
        super();
        this.Dati = [];
    }
}

export class CRisAPIDatoTipi<T> extends CRisAPIDato<T> {
    Tipi: { [T: string]: TDictTipo } = {};
    public LeggiTipi(Tipo: string): TDictTipo {
        if (!this.Tipi.hasOwnProperty(Tipo)) {
            this.Tipi[Tipo] = {};
        }
        return this.Tipi[Tipo];
    }
}

export class InfoContesto {
    Nome: string = "";
    urlAPI: string = "";
    urlRitorno: string = "";
    Dati: any[] = [];

    constructor(nome: string, urlapi: string, urlritorno: string, dati?: any[]) {
        this.Nome = nome;
        this.urlAPI = urlapi;
        this.urlRitorno = urlritorno;
        if (dati != undefined) this.Dati = dati;
        else this.Dati = [];
    }
}

export class CDatiContesto {
    Etichetta: string = "";
    Valore: any = "";
    ParametroTrad: string = "";
}

export class CRisAPIListaContesto extends CRisAPILista<CDatiContesto> {
    constructor() {
        super();
        this.Dati = [];
    }
}

export class CRisAPISempliceTipi<T> extends CRisAPISemplice<T> {
    Tipi: { [T: string]: TDictTipo } = {};
}

export class CRisAPIPagineTipi<T> extends CRisAPIPagine<T> {
    Tipi: { [T: string]: TDictTipo } = {};
}

export class CRisAPIListaTipi<T> extends CRisAPILista<T> {
    Tipi: { [T: string]: TDictTipo } = {};
}

export class CRisAPIDatoInfo<T> extends CRisAPIDato<T> {
    Info: { [I: string]: CInfoCampo } = {};
}

export class CRisAPISempliceInfo<T> extends CRisAPISemplice<T> {
    Info: { [I: string]: CInfoCampo } = {};
}

export class CRisAPIPagineInfo<T> extends CRisAPIPagine<T> {
    Info: { [I: string]: CInfoCampo } = {};
}

export class CRisAPIListaInfo<T> extends CRisAPILista<T> {
    Info: { [I: string]: CInfoCampo } = {};
}

export class CRisAPIDatoTipiInfo<T> extends CRisAPIDato<T> {
    Tipi: { [T: string]: TDictTipo } = {};
    Info: { [I: string]: CInfoCampo } = {};
}

export class CRisAPISempliceTipiInfo<T> extends CRisAPISemplice<T> {
    Tipi: { [T: string]: TDictTipo } = {};
    Info: { [I: string]: CInfoCampo } = {};
}

export class CRisAPIPagineTipiInfo<T> extends CRisAPIPagine<T> {
    Tipi: { [T: string]: TDictTipo } = {};
    Info: { [I: string]: CInfoCampo } = {};
}

export class CRisAPIListaTipiInfo<T> extends CRisAPILista<T> {
    Tipi: { [T: string]: TDictTipo } = {};
    Info: { [I: string]: CInfoCampo } = {};
}

interface IDatiSessione {
    ID_Utente: number;
    ID_UtenteImpersonato: number;
    ID_Anag: number;
    DataRiferimento?: Date;
    Login: string;
    Livello: number;
    Sessione: string;
    Scadenza: Date;
    ScadenzaMax: Date;
    Immagine: string;
    Nome: string;
    Cognome: string;
    Email: string;
    SecondaPassword: boolean;
    Autorizzazioni: Dictionary<number>;
    Limiti: CRisAPI_DatiLimiti;
    Gruppi: string[];
    ConfigurazioneCompilazione: string;
    Versione: string;
}

export class CDatiPolizza {
    ID_TipoRamo: number = 0;
    ID_TipoProdotto: number = 0;
    ID_Polizza: number = 0;
    ID_AnagContraente: number = 0;
    ID_AnagPOS: number = 0;
    AnagPOS: string = "";
    Polizza: string = "";
    Contraente: string = "";
    ContraenteATI: string = "";
    DatiPolizza: Glob.DatiJSON = "";
    CodiceControllo: string = "";
    ID_TipoPolizzaStato: string = "";
    StatoPolizza: string = "";
    DataEffetto: Date = new Date(Date.now());
    DataFine: Date = new Date(Date.now());
    DataInizioCopertura?: Date = new Date(Date.now());
    DataFineCopertura?: Date = new Date(Date.now());
    TipoProdotto: string = "";
    TipoRamo: string = "";
    CoAssicurazioneJSON: Glob.DatiJSON = "";
    ListaPolizzaApprovazioneJSON: Glob.DatiJSON = "[]";
    ID_TipoFileRichiesto: string = "";
    FileJSON: Glob.DatiJSON = "";
    ID_TipiRicercaDate: string = "";
    DataEmissione?: Date = new Date(Date.now());
    Note?: string;
    AppendiciJSON: Glob.DatiJSON = "";
    Intermediary?: string;
    RenewalsJSON: Glob.DatiJSON = "";
}
export class CDatiPolizzaAnnullamento extends CDatiPolizza{

    TipologiaAnnullamento: number;
}
export class CDatiPolizzaGenerale {
    ID_Polizza: number = 0;
    Polizza: string = "";
    Contraente: string = "";
    DataEffetto: Date = new Date(Date.now());
    DataFine: Date = new Date(Date.now());
    DataInizioCopertura?: Date = new Date(Date.now());
    DataFineCopertura?: Date = new Date(Date.now());
    TipoProdotto: string = "";
    TipoRamo: string = "";
    ID_TipoRamo: number = 0;
    ID_TipoProdotto: number = 0;
    AnagPOS: string = "";
    ID_AnagContraente: number = 0;
    ID_FideAffidamento: number = 0;
    StatoPolizza: string = "";
    ID_TipoPolizzaStato: string = "";
    Modificato: Date = new Date(Date.now());
    DataEmissione: Date = new Date(Date.now());
    ID_TipiRicercaDate: string = "";
    TacitoRinnovo: boolean = false;
    Sinistro: string = "";
    SinistroNote: string = "";
    DataSinistro?: Date;
    Appendici: string = "";
    ID_PolizzaRinnovata: number = 0;
    PolizzaRinnovata: string = "";
    ImportoGarantito?: number;
}

export class CRisAPI_DatiPolizzaCodiceControllo extends CRisAPI {
    CodiceControllo: string = "";
    ID_Polizza: number = 0;
    Polizza: string = "";
    Contraente: string = "";
    Beneficiario: string = "";
    ImportoGarantito: number = 0;
    DataEmissione: Date = new Date(Date.now());

    //Serve?
    constructor() {
        super();
    }
}

export class CDatiAnagBreve {
    ID_Anag: number = 0;
    Nome: string = "";
    Cognome: string = "";
    CodiceFiscale: string = "";
    DatiProfessionaliJSON: Glob.DatiJSON = "";
}

export class CDatiAnag extends CDatiAnagBreve {
    ID_AnagCapoGruppo: number = 0;
    RagioneSociale: string = "";
    PartitaIVA: string = "";
    Indirizzo: string = "";
    Citta: string = "";
    CAP: string = "";
    Provincia: string = "";
    Nazione: string = "";
    LuogoNascita: string = "";
    Telefono: string = "";
    Cellulare: string = "";
    Fax: string = "";
    Email: string = "";
    Pec: string = "";
    TipoRecapito: string = "";
    TipoIndirizzo: string = "";
    LegaleRappresentante: string = "";
    ID_LegaleRappresentante: number = 0;
    ID_TipoAnagPrincipale: string = "";
    ID_TipoAnagStato: string = "";
    TipoAnagStato: string = "";
    TipoAnag: string = "";
    DataNascita?: Date = undefined;
    Sesso: string = "";
    ID_AnagLegaleRappresentante: number = 0;
    ID_TipoSocieta: number = 0;
    RecapitiJSON: Glob.DatiJSON = "";
    IndirizziJSON: Glob.DatiJSON = "";
    MandantiJSON: Glob.DatiJSON = "";
    ID_AnagAppartenenza: number = 0;
    DocNumber: string = "";
    DocIssuedBy: string = "";
    DocIssuedOn?: Date = undefined;
}

export class CDatiPolicyFile {
    ID_File: number = 0;
    Data: any;
    Link: string = "";
    State: string = "";
    FirstName: string = "";
    LastName: string = "";
    DocType: string = "";
    DocNumber: string = "";
    Phone: string = "";
    Email: string = "";
}

export class CDatiRequestPolicyFile {
    ID_Anag: number = 0;
    ID_Polizza: number = 0;
    ID_TipoProdotto: number = 0;
    ID_BinderCompagnia: number = 0;
    ID_TipoPolizzaStato: string = "";
    isJson: boolean = true;
    isFile: boolean = false;
}

export class CDatiRequestDigitalSignature {
    PolicyFile: CDatiRequestPolicyFile;
    Polizza: string = "";
    FirstName: string = "";
    LastName: string = "";
    DocType: string = "";
    DocNumber: string = "";
    Phone: string = "";
    Email: string = "";
}

export class CDatiGruppoAutorizzazioni {
    Autorizzazioni: CDatiGruppoAutorizzazione[] = [];
}

export class CDatiGruppoAutorizzazione {
    ID_Gruppo: string = "";
    ID_Funzione: string = "";
    Descrizione: string = "";
    Azione: number = 0;
}

export class CDatiUtente {
    ID_Utente: number = 0;
    Login: string = "";
    Password: string = ""; //Solo in fase di creazione di un nuovo utente
    Livello: number = 0;
    ID_Anag: number = 0;
    Immagine: string = "";
    Nome: string = "";
    Cognome: string = "";
    Email: string = "";
    LinguaNotifiche: string = "IT";
}

export class CDatiUtenteGruppi extends CDatiUtente {
    Gruppi: Dictionary<boolean> | undefined = undefined;
}

export class CDatiGruppo {
    ID_Gruppo: string = "";
    Gruppo: string = "";
}

export class CDatiStato {
    ID_TipoCambioStato: string = "";
    ID_Gruppo: string = "";
    ID_TipoCambioStatoPercorso: string = "";
    ID_TipoStatoPartenza: string = "";
    ID_TipoStatoArrivo: string = "";
    AzioniJSON: Glob.DatiJSON = "";
    ListaGruppiNotificaJSON: Glob.DatiJSON = "";
    Ordine: number = 0;
    Note: string = "";
    ID_CambioStatoRiga: number = 0;
    Attivo: boolean = true;
}

export class CDatiEconomici {
    ID_DatoEconomico: number = 0;
    ID_Anag: number = 0;
    Data: Date = new Date(Date.now());
    AnnoBilancio: number = new Date(Date.now()).getFullYear() - 1;
    Fatturato: number = 0;
    PatrimonioNetto: number = 0;
    AnnoUnico: number = new Date(Date.now()).getFullYear();
    RedditoImmobili: number = 0;
    RedditoComplessivo: number = 0;
    MargineOperativoLordo: number = 0;
    AttivoCircolante: number = 0;
    DebitiBreve: number = 0;
    ValoreProduzioneUltimoAnno: number = 0;
    ValoreProduzioneAnnoPrecedente: number = 0;
    TotalePassivo: number = 0;
    DebitiOltreBTVersoBanche: number = 0;
    DebitiCorrentiVersoBanche: number = 0;
    AttivitaFinanziarie: number = 0;
    Liquidita: number = 0;
    PassivoConsolidato: number = 0;
    PassivoCorrente: number = 0;
    Commenti: string = "";
    ISO: string = "";
    IndiceSettorialeCurrentRatio: number = 0;
    IndiceSettorialeROS: number = 0;
    IndiceSettorialeOneriFinanziariValoreProduzione: number = 0;
    IndiceSettorialeDurataMediaDeiDebiti: number = 0;
    IndiceSettorialeAssetTurnover: number = 0;
    IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni: number = 0;
    IndiceSettorialeROE: number = 0;
    IndiceSettorialeQuickRatio: number = 0;
    IndiceSettorialeCoperturaInteressi: number = 0;
    IndiceSettorialeROI: number = 0;
    IndiceSettorialeLeverage: number = 0;
    DataCostituzione: Date = new Date(Date.now());
    Pregiudizievoli: string = "";
    Protesti: string = "";
    ProcedureConcorsuali: string = "";
    Classificazione: string = "";
    NumeroDipendenti: number = 0;
    Punteggio: number = 0;
    NomeFileReport: string = "";
}

class CDatiAnagVeloce {
    ID_Anag: number = 0;
    Denominazione: string = "";
    ID_TipoAnag: string = "";
}

export interface IAzioniMenu {
    Azione: string;
    Icona: string;
    URL: string;
    Abilitazione: Glob.Azioni;
}

export interface IDatiMenu {
    ID_Menu: number;
    Indirizzo: string;
    Voce: string;
    Icona: string;
    Azioni?: IAzioniMenu[];
    ID_Funzione: Glob.Funzioni;
}

export class CDatiBinder {
    ID_Binder: number = 0;
    ID_AnagA: number = 0;
    ID_AnagDa: number = 0;
    AnagA: string = "";
    AnagDa: string = "";
    CodiceBinder: string = "";
    CoAssicurazioneMinima: number = 0;
    CoAssicurazioneSoloDelegataria: boolean = true;
    DataStipula?: Date = undefined;
    DataEffetto?: Date = undefined;
    DataFine?: Date = undefined;
}

export class CDatiEstrattoConto {
    ID_EstrattoConto = 0;
    ID_AnagA = 0;
    ID_AnagDa = 0;
    AnagA = "";
    AnagDa = "";
    DataDa: Date;
    DataA: Date;
    Totale = 0;
    ID_TipoEstrattoContoStato = Glob.Tipi_ECS_Aperto;
    PagamentoData?: Date;
    PagamentoImporto?: number;
    Note?: string;
}

export class CDatiQuietanzeEstrattoConto {
    ID_Quietanza = 0;
    DataEmissione: Date;
    DataRichiestoPagamento: Date;
    DataPagamento?: Date;
    ID_EstrattoConto?: number;
    ID_Polizza = 0;
    Polizza = "";
    ID_AnagContraente = 0;
    AnagContraente = "";
    ID_TipoRamo = 0;
    ID_TipoProdotto = 0;
    TipoRamo = "";
    TipoProdotto = "";
    ID_BinderCompagnia = 0;
    Compagnia = "";
    PremioLordoDare = 0;
    ProvvigioniDare = 0;
    PremioLordoAvere = 0;
    ProvvigioniAvere = 0;
    Extra: CDatiQuietanzeEstrattoImportiExtra[] = [];
    ID_TipoQuietanzaStato = "";
    Selezionata = false;
}

export class CDatiEstrattoContoDettaglio extends CDatiQuietanzeEstrattoConto {
    ID_EstrattoContoDettaglio = 0;
    PercRitenuta?: number;
    Ritenuta?: number;
}

export class CDatiQuietanzeEstrattoImportiExtra {
    Nome: string;
    Importo: number;
}

export class CDatiQuietanzeEstrattoContoExtra {
    Totale = 0;
}

export class CDatiQuietanzeEstrattoContoIngrExtra {
    ID_AnagA = 0;
    DataDa: Date;
    DataA: Date;
}

export class CDatiBinderProdotto {
    Compagnia: string = "";
    ID_Binder: number = 0;
    ID_TipoProdotto: number = 0;
    TipoProdotto: string = "";
    ID_TipoRamo: number = 0;
    TipoRamo: string = "";
    LimitePerSingoloProdotto: number = 0;
    LimitePerSingoloProdottoMAX: number = 0;
    LimitePerSingoloContraente: number = 0;
    LimitePerSingoloContraenteMAX: number = 0;
    LimiteDirittiFissi: number = 0;
    LimiteDirittiFissiMAX: number = 0;
    LimiteAccessori: number = 0;
    LimiteAccessoriMAX: number = 0;
    LimiteFlessibilita: number = 0;
    LimiteFlessibilitaMAX: number = 0;
    PremioMinimo: number = 0;
    PremioMinimoMAX: number = 0;
    Provvigioni: number = 0;
    ProvvigioniMAX: number = 0;
    Checked: boolean = false;
    ListaApprovazioniRichiesteJSON: Glob.DatiJSON = "[]";
    TacitoRinnovo: boolean = false;
    EmissioneDirettaPOS = false;
    EmissioneOrarioUfficio: boolean = false;
    Files: CDocument[] = [];
}

export class CDatiTrad {
    ID_Trad: number = 0;
    ID_TipoTrad?: number = 0;
    Lingua: string = "";
    Testo: string = "";
    Trad: string = "";
}

export class CDatiFile {
    ID_File: number = 0;
    ID_Chiave: number = 0;
    ID_TipoFile: string = "";
    ID_TipoFileStato: string = "";
    ID_TipoFileChiave: string = "";
    ID_Utente: number = 0;
    NomeFile: string = "";
    SHA256: string = "";
    MIME: string = "";
    TipoDocumento: string = "";
    NumeroDocumento: string = "";
    RilasciatoDa: string = "";
    DataRilascio: Date = new Date(Date.now());
    DataScadenza: Date | undefined = undefined;
    Note: string = "";
    Modificato: Date = new Date(Date.now());
    TipoFile: string = "";
    TipoFileStato: string = "";
    UtenteAnag: string = "";
}

export class CQuietanza {
    ID_Quietanza: number = 0;
    ID_Polizza: number = 0;
    Polizza: string = "";
    ID_TipoQuietanza: string = "";
    TipoQuietanza: string = "";
    Progressivo: number = 0;
    ID_TipoQuietanzaStato: string = "";
    TipoQuietanzaStato: string = "";
    DataInizioCopertura: Date = new Date(Date.now());
    DataFineCopertura: Date = new Date(Date.now());
    PremioJSON: Glob.DatiJSON = "[]";
    ProvvigioniJSON: Glob.DatiJSON = "[]";
    Attivo: boolean = true;
}

export class CDatiFileCheckListBase {
    constructor(id_file: number) {
        this.ID_File = id_file;
    }
    ID_File: number = 0;
}

export class CDatiFileCheckList extends CDatiFileCheckListBase {
    Necessario: boolean = false;
    ID_Chiave: number = 0;
    ID_TipoFile: string = "";
    ID_TipoFileStato: string = "";
    TipoFileStato: string = "";
    NomeFile: string = "";
    Tipo: string = "";
    MIME: string = "";
    Selezionato: boolean = false;
}

export class CDatiCheckListFileBase {
    FileCaricati: CDatiFileCheckListBase[] = [];
    Validato: boolean = false;
    Note: string = "";
}

export class CDatiCheckListFile extends CDatiCheckListFileBase {
    FileCaricati: CDatiFileCheckList[] = [];
}

export class CDatiDeroga {
    ID_Deroga: number = 0;
    DerogaJSON: Glob.DatiJSON = "";
    ID_TipoDerogaStato: string = "";
    Stato: string = "";
    ID_TipoDerogaTipo: string = "";
    Tipo: string = "";
    Note: string = "";
    Elaborata: boolean = false;
    Derogabile: boolean = false;
    VersoDeroga: string = "";
    Creato: Date = new Date(Date.now());
    Abilitato: boolean = false;
}

export class CDatiRecuperaPassword {
    Email: string = "";
    ID_Utente: number = 0;
    Nome: string = "";
    Cognome: string = "";
    Codice: string = "";
    Password: string = "";
}

export class CAnagrafica {
    ID_Anag: number = 0;
    ID_TipoAnagStato: string = "";
    ID_TipoAnagPrincipale: string = "";
    Nome: string = "";
    Cognome: string = "";
    CodiceFiscale: string = "";
    DataNascita?: Date = undefined;
    LuogoNascita: string = "";
    Sesso: string = "";
    RagioneSociale: string = "";
    ID_TipoSocieta: number = 0;
    ID_AnagCapoGruppo: number = 0;
    PartitaIVA: string = "";
    ID_AnagLegaleRappresentante: number = 0;
}

export class CBancaDatiGare {
    ID_BancaDatiGara: number = 0;
    ID_Anag: number = 0;
    ID_Utente: number = 0;
    CIG: string = "";
    NumeroUtilizzi: number = 0;
    DataGara?: Date = undefined;
    DataPresentazione?: Date = undefined;
    ImportoGarantito?: number = undefined;
    ImportoComplessivo?: number = undefined;
    OggettoGaranzia?: string = undefined;
    RibassoAsta?: number = undefined;
    LuogoEsecuzione?: string = undefined;
    Modificato: Date = new Date();
}

export type CRisAPIDatoSessioni = CRisAPIDato<IDatiSessione>;
export type CRisAPIPagineTipi_Anag = CRisAPIPagineTipi<CDatiAnag>;
export type CRisAPIPagineUtenti = CRisAPIPagine<CDatiUtente>;
export type CRisAPIPagineGruppo = CRisAPIPagine<CDatiGruppo>;
export type CRisAPIPagineNews = CRisAPIPagine<CNews>;
export class CRisAPIDatoTipiBinder extends CRisAPIDatoTipi<CRisAPIExtra<CDatiBinder, CDatiBinderProdotto[]>> {
    constructor() {
        super();
        this.Dato = new CRisAPIExtra<CDatiBinder, CDatiBinderProdotto[]>();
        this.Dato.RisAPI = new CDatiBinder();
        this.Dato.Extra = [];
        this.Tipi = {};
    }
}
export class CRisAPIDatoTipiFile extends CRisAPIDatoTipi<CDatiFile> {
    constructor() {
        super();
        this.Dato = new CDatiFile();
        this.Tipi = {};
    }
}
export class CRisAPIListaFileChecklist extends CRisAPILista<CDatiFileCheckList> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export class CRisAPIDatoDatiEconomici extends CRisAPIDato<CDatiEconomici> {
    constructor() {
        super();
        this.Dato = new CDatiEconomici();
    }
}
export class CRisAPIListaBinderProdotto extends CRisAPILista<CDatiBinderProdotto> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export type CRisAPIPagineBinder = CRisAPIPagine<CDatiBinder>;
export type CRisAPIPagineEstrattoConto = CRisAPIPagineTipi<CDatiEstrattoConto>;
export type CRisAPIListaEstrattoContoQuietanze = CRisAPIExtra<CRisAPIListaTipi<CDatiQuietanzeEstrattoConto>, CDatiQuietanzeEstrattoContoExtra>;
export type CRisAPIListaEstrattoContoDettagli = CRisAPIExtra<CRisAPIListaTipi<CDatiEstrattoContoDettaglio>, CDatiEstrattoConto>;
export type CRisAPIPaginePolizza = CRisAPIPagine<CDatiPolizza>;
export type CRisAPIPaginePolizzaGenerale = CRisAPIPagineTipi<CDatiPolizzaGenerale>;
export type CRisAPIPagineDatiEconomici = CRisAPIPagine<CDatiEconomici>;
export type CRisAPIListaAnagVeloce = CRisAPILista<CDatiAnagVeloce>;
export type CRisAPIListaMenu = CRisAPILista<IDatiMenu>;

export type CRisAPIListaDocumenti = CRisAPIPagine<CDatiFile>;

export type CRisAPIListaPolizza = CRisAPILista<CDatiPolizza>;
export class CRisAPIListaTipo extends CRisAPILista<CTipo> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export class CRisAPIPagineFile extends CRisAPIPagine<CDatiFile> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export class CRisAPIPagineQuietanze extends CRisAPIPagine<CQuietanza> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export class CRisAPIPagineDeroga extends CRisAPIPagine<CDatiDeroga> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export class CRisAPIPagineAppendice extends CRisAPIPagine<CAppendiceTestata> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export class CRisAPIListaTrad extends CRisAPILista<CDatiTrad> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export class CRisAPIAnagraficaBreve extends CRisAPILista<CDatiAnagBreve> {
    constructor() {
        super();
        this.Dati = [];
    }
}
export class CRisAPIDatoTipiInfo_Anag extends CRisAPIDatoTipiInfo<CDatiAnag> {
    constructor() {
        super();
        this.Dato = new CDatiAnag();
        this.Tipi = {};
        this.Info = {};
    }
}

export class CRisAPIDatoTipiInfoUtente extends CRisAPIDatoTipiInfo<CDatiUtente> {
    constructor() {
        super();
        this.Dato = new CDatiUtente();
    }
}
export class CRisAPIDatoTipiInfo_Polizza extends CRisAPIDatoTipiInfo<CDatiPolizza> {
    constructor() {
        super();
        this.Dato = new CDatiPolizza();
    }
}

export class CRisAPIDatoTipiInfoNews extends CRisAPIDatoTipiInfo<CNews> {
    constructor() {
        super();
        this.Dato = new CNews();
        // this.Tipi = {};
        // this.Info = {};
    }
}

export class CDatiANAC {
    CIG: string = "";
    Gara: string = "";
    Oggetto: string = "";
    DataOfferta: Date | undefined = undefined;
    ImportoGara: number = 0;
    DataAggiudicazione: Date | undefined = undefined;
    ImportoAggiudicazione: number = 0;
    Ribasso: number = 0;
}

export class CDocument {
    ID_Document: number = 0;
    OriginalFileName: string = "";
    DownloadFileName: string = "";
    Description: string = "";
    SHA256: string = "";
    MIME: string = "application/nd";
    Provider: string = "Azure";
    Version: number = 1;
    GroupName: string;
}

//export class CDocumentList {
//    ID_DocumentList: number = 0;
//    Group: string;
//    FileName: string;
//    SHA256: string;
//    MIME: string;
//    Provider: string;
//    GroupsJSON: string;
//}

export class CDocumentExtended extends CDocument {
    ExtendedValues?: Dictionary<any> = {};
}

/* GRAFICI INIZIO */
export class ChartData {
    labels: string[] = [];
    datasets: ChartDataSets[] = [];
}
export class ChartDataSets {
    label?: string;
    data: number[] = [];
    backgroundColor: string[] = [];
    borderColor: string[] = [];
    borderWidth: number = 1;
}
/* GRAFICI FINE */

/// <summary>
/// IBaseProps è l'interfaccia di base che tutti i componenti devono estendere per le proprie proprietà
/// </summary>
/// <param name="Lettura">Indica se il componente è leggibile, in caso fosse false andrà oscurato il componente</param>
/// <param name="Scrittura">Indica se il componente è scrivibile, in caso fosse false il controllo è solo leggibile (sempre se attivo in lettura)</param>
/// <param name="Data">Indica a che data bisogna visualizzare i dati nel controllo</param>
/// <param name="OnChange">Evento da cambiare al change dello stato</param>
export interface IBaseProps {
    Id: string;
    Visibile?: boolean;
    Scrittura?: boolean;
    Richiesto?: boolean;
    Name: string;
    CSS?: string;
    RegoleValidazione?: string;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => void;
    OnBlur?: (e: React.FormEvent<any> | string, valore?: any) => void;
}

export interface IBaseTabellaProps extends IBaseProps {
    Dati?: any[]; //Righe della tabella
    Sort?: (Campo: string, Verso: string) => void;
}

export interface ITabellaListaProps extends IBaseTabellaProps {
    PopolaColonne: (RDati?: any[], Sort?: (Campo: string, Verso: string) => void) => React.ReactNode;
    PopolaRighe: (RDati?: any[], Funzione1?: (e: any) => any, Funzione2?: (e: any) => any, Funzione3?: (e: any, d: any) => any) => React.ReactNode;
    Funzione1?: (e: any) => any;
    Funzione2?: (e: any) => any;
    Funzione3?: (e: any, d: any) => any;
}

export class CCampo {
    Campo: string = "";
}

export class CCampoStruttura extends CCampo {
    Etichetta: string = "";
    ID_TipoCampo: number = 1;
    DimensioneGrafica: number = 1; //MAX 11 (1 dimensione etichetta) (12 per i checkbox che hanno etichetta integrata)
    Parametri: Dictionary<string> = {};
}

export class CCampoDato extends CCampo {
    Valore: any;
}

export class CFideAffidamentoApprovazione {
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
    ID_AnagDa: number = 0;
    ID_AnagA: number = 0;
    ID_TipoFideAffidamentoApprovazione: string = Glob.Tipi_FAA_Proposta;
    //TODO Utilizzare componente apposito per "chat"
    CommentiGruppi: { [T: string]: string } = {};
    Data: Date = new Date(Date.now());
}

export class CPolizzaApprovazioneBase {
    ID_Polizza: number = 0;
    ListaPolizzaApprovazioneJSON: Glob.DatiJSON = "";
}

export class CPolizzaApprovazione {
    ID_Binder: number = 0;
    ID_BinderCompagnia: number = 0;
    ID_AnagDa: number = 0;
    ID_AnagA: number = 0;
    ID_TipoPolizzaApprovazione: string = Glob.Tipi_PA_Proposta;
    //TODO Utilizzare componente apposito per "chat"
    CommentiGruppi: { [T: string]: string } = {};
    Data: Date = new Date(Date.now());
}

export class CFatturaDatiEconomici {
    ID_FatturaDatiEconomici: number = 0;
    ID_TipoFornitore: string = "";
    Identificativo: string = "";
    DataRiferimentoDocumento: Date = new Date(Date.now());
    DatiFatturaJSON: Glob.DatiJSON = "{}";
    Creato: Date = new Date(Date.now());
}

export class CFatturaDatiEconomiciMatch extends CFatturaDatiEconomici {
    MatchJSON: Glob.DatiJSON = "[]";
}

export class CRisAPIPagineTipi_FattureDatiEconomici extends CRisAPIPagineTipi<CFatturaDatiEconomici> {
    constructor() {
        super();
        this.Dati = [];
        this.Tipi = {};
    }
}

export class CDashboardUltimiAggiornamentiPolizza extends CDatiPolizzaGenerale {
    Nome: string = "";
    Cognome: string = "";
    Immagine: string = "uomo";
    Company: string = "";
}

export class CDashboardUltimiAggiornamentiFideAffidamento {
    Nome: string = "";
    Cognome: string = "";
    Immagine: string = "uomo";
    ID_FideAffidamento: number = 0;
    ID_AnagDa: number = 0;
    ID_AnagA: number = 0;
    ID_TipoFideAffidamentoEsito: string = "";
    DenominazioneDa: string = "";
    DenominazioneA: string = "";
    RigaInizio: Date = new Date();
}

export class CDashboardUltimiAggiornamentiDeroga {
    Nome: string = "";
    Cognome: string = "";
    Immagine: string = "";
    ID_Deroga: number = 0;
    ID_TipoDerogaTipo: string = "";
    ID_TipoDerogaStato: string = "";
    Note: string = "";
    Polizza: string = "";
    RigaInizio: Date = new Date();
}

export class CNews {
    Category: string = "";
    Description: string = "";
    ID_News: number = 0;
    NewsDate: string = "";
    Title: string = "";
}

export class CDatiTipoProdotto {
    TipoContestoBase: string = "";
    TipoContestoGaranzie: string = "";
    ID_TipoFileRichiesto: string = "";
    ID_TipiProdotti: number[] = [];
}

export class CAddendum {
    ID_Appendice: number = 0;
    Numero: number = 0;
    Temporanea: string = "0";
    ID_TipoAppendice: string = "";
    ID_TipoAppendiceStato: string = "AS-Preventivo";
    DataInizio: Date = new Date(Date.now());
    DataFine: Date = new Date(Date.now());
    DataEmissione: Date = new Date(Date.now());
    Testo: string = "";
    PremioNetto: number = 0; 	
    Accessori: number = 0;
    DirittiDiEmissione: number = 0;	
    Imponibile: number = 0;	
    Imposte: number = 0;	
    PremioFinito: number = 0;
    ImportoGarantito?: number;
    TassoInteresseLegale?: number;
    ContributoConsap?: number;
}

export class CRinnovo {
    ID_Rinnovo: number = 1;
    DataInizio: Date = new Date(Date.now());
    DataFine: Date = new Date(Date.now());
    
    Domanda1: boolean = false;
    Domanda2: boolean = false;
    Domanda3: boolean = false;
    NuovoFatturato: number = 0;
    
    DataSinistro?: Date;
    Sinistro: string = "";
    SinistroNote: string = "";
    
    Note: string = "";
    NoteQ1: string = "";
    NoteQ3: string = "";

    DataEmissione?: Date;
}

export class CAppendice {
    Testata: CAppendiceTestata = new CAppendiceTestata();
    Dati: CAppendiceDati[] = [];
}

export class CAppendiceTestata {
    ID_Appendice: number = 0;
    ID_TipoAppendice: string = "";
    ID_TipoAppendiceStato: string = "AS-Preventivo";
    ID_Polizza: number = 0;
    Polizza: string = "";
    NumeroAppendice: number = 1;
    PolizzaAppendice: string = "";
    Nota: string = "";
    DataEffetto: Date = new Date(Date.now());
    DataScadenza: Date = new Date(Date.now());
}

export class CAppendiceDati {
    ID_Appendice: number = 0;
    ID_TipoCampo: number = 0;
    Etichetta: string = "";
    CampoAppendice: string = "";
    ValoreAppendice: string = "";
}

/* DTO Comuni non segue la nomenclatura standard perché esportato da fonte dati esterna INIZIO */
//https://github.com/matteocontrini/comuni-json
export class CZona {
    nome: string = "";
    codice: string = "";
}

export class CRegione {
    codice: string = "";
    nome: string = "";
}

export class CCm {
    codice: string = "";
    nome: string = "";
}

export class CProvincia {
    codice: string = "";
    nome: string = "";
}

export class CComune {
    nome: string = "";
    codice: string = "";
    zona = new CZona();
    regione = new CRegione();
    cm = new CCm();
    provincia = new CProvincia();
    sigla: string = "";
    codiceCatastale: string = "";
    cap: string[] = [];
    popolazione: number = 0;
}
/* DTO Comuni non segue la nomenclatura standard perché esportato da fonte dati esterna FINE */



// WEBPACK FOOTER //
// ./src/Dati.tsx